export const RESULT_MINE_TYPE='image/jpeg';